import { render, staticRenderFns } from "./PsnStatutoryGrid.vue?vue&type=template&id=69da72a4"
import script from "./PsnStatutoryGrid.vue?vue&type=script&lang=js"
export * from "./PsnStatutoryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports